module.exports = __webpack_public_path__ + "img/error.f70bf800.svg";